import { type LoaderFunctionArgs } from '@remix-run/node'
import { json } from '@remix-run/react'
import { z } from 'zod'

export type ChatVariant = 'full' | 'embed'

export const MAX_QUERY_LENGTH = 500

export const QuerySchema = z
	.string()
	.max(MAX_QUERY_LENGTH, 'Sökfrågan är för lång.')
	// Require a letter after `<` so comparisons like "GFR < 30" survive.
	.transform(val => val.replace(/<\/?[a-zA-Z][^>]*>?/g, ''))
	.transform(val => val.trim())
	.transform(val => (val === '' ? null : val))
	.nullable()

/**
 * Fallback UUID generator for non-secure contexts (HTTP) used in local dev.
 */
export function generateUUID() {
	if (typeof crypto !== 'undefined' && crypto.randomUUID) {
		return crypto.randomUUID()
	}
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		const r = (Math.random() * 16) | 0
		const v = c === 'x' ? r : (r & 0x3) | 0x8
		return v.toString(16)
	})
}

/**
 * Shared loader for routes that read a `?q=` query param and auto-submit it.
 * Used by `/` and `/embed`.
 */
export async function chatQueryLoader({ request }: LoaderFunctionArgs) {
	const url = new URL(request.url)
	const rawQuery = url.searchParams.get('q')
	const result = QuerySchema.safeParse(rawQuery)
	const query = result.success ? result.data : null
	return json({ query })
}
